<div class="overview-filter-bar">
  <span class="overview-filter-bar__search">
    <i class="pi pi-search"></i>
    <input
      pInputText
      type="text"
      [(ngModel)]="searchValue"
      (ngModelChange)="onSearchChange()"
      placeholder="Szukaj..."
      class="overview-filter-bar__search-input"
    />
  </span>
  <p-multiSelect
    [options]="categoryOptions"
    [(ngModel)]="selectedCategoryIds"
    (onChange)="onFilterChange()"
    optionLabel="label"
    optionValue="value"
    [filter]="true"
    filterPlaceholder="Szukaj..."
    [showClear]="false"
    [appendTo]="'body'"
    placeholder="Filtruj po dziale"
    styleClass="overview-filter-bar__dropdown"
    [style]="{ maxWidth: '220px', minWidth: '150px', height: '40px' }"
  ></p-multiSelect>
  <p-multiSelect
    [options]="topicOptions"
    [(ngModel)]="selectedTopicIds"
    (onChange)="onFilterChange()"
    optionLabel="label"
    optionValue="value"
    [filter]="true"
    filterPlaceholder="Szukaj..."
    [showClear]="false"
    [appendTo]="'body'"
    placeholder="Filtruj po rozdziale"
    styleClass="overview-filter-bar__dropdown"
    [style]="{ maxWidth: '220px', minWidth: '150px', height: '40px' }"
  ></p-multiSelect>
  <p-multiSelect
    [options]="examOptions"
    [(ngModel)]="selectedExamGuids"
    (onChange)="onFilterChange()"
    optionLabel="examName"
    optionValue="guid"
    [filter]="true"
    filterPlaceholder="Szukaj..."
    [showClear]="false"
    [appendTo]="'body'"
    placeholder="Filtruj po kategorii egzaminu"
    styleClass="overview-filter-bar__dropdown"
    [style]="{ maxWidth: '220px', minWidth: '150px', height: '40px' }"
  ></p-multiSelect>
</div>

<p-table
  [value]="categories"
  dataKey="id"
  [expandedRowKeys]="expandedCategories"
  (onRowExpand)="onCategoryRowExpand($event)"
  (onRowCollapse)="onCategoryRowCollapse($event)"
  [loading]="isLoading"
  styleClass="overview-table"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 3rem"></th>
      <th>Nazwa działu</th>
      <th>Liczba rozdziałów</th>
      <th>Kategorie egzaminów</th>
      <th style="width: 4rem">Akcje</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-category let-expanded="expanded">
    <tr>
      <td>
        <button
          type="button"
          pButton
          pRipple
          [pRowToggler]="category"
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
          data-clarity-unmask="true"
        ></button>
      </td>
      <td class="name-col">{{ category.name }}</td>
      <td>{{ category.topics.length }}</td>
      <td>{{ getExamNames(category) }}</td>
      <td>
        <button
          type="button"
          class="pi pi-pencil cursor-pointer text-center appear transparent-button"
          pTooltip="Edytuj dział"
          tooltipPosition="bottom"
          (click)="openCategoryDetails(category)"
          data-clarity-unmask="true"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-category>
    <tr>
      <td colspan="5">
        <div class="nested-table-wrapper">
          <p-table
            [value]="category.topics"
            dataKey="id"
            [expandedRowKeys]="expandedTopics"
            (onRowExpand)="onTopicRowExpand($event)"
            (onRowCollapse)="onTopicRowCollapse($event)"
            styleClass="overview-table-nested"
          >
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem"></th>
                <th>Nazwa rozdziału</th>
                <th>Liczba slajdów</th>
                <th style="width: 4rem">Akcje</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-topic let-expandedTopic="expanded">
              <tr>
                <td>
                  <button
                    type="button"
                    pButton
                    pRipple
                    [pRowToggler]="topic"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="expandedTopic ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    data-clarity-unmask="true"
                  ></button>
                </td>
                <td class="name-col">{{ topic.name }}</td>
                <td>{{ topic.slides.length }}</td>
                <td>
                  <button
                    type="button"
                    class="pi pi-pencil cursor-pointer text-center appear transparent-button"
                    pTooltip="Edytuj rozdział"
                    tooltipPosition="bottom"
                    (click)="openTopicDetails(category, topic)"
                    data-clarity-unmask="true"
                  ></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-topic>
              <tr>
                <td colspan="4">
                  <div class="nested-table-wrapper">
                    <p-table [value]="topic.slides" dataKey="id" styleClass="overview-table-nested">
                      <ng-template pTemplate="header">
                        <tr>
                          <th>Kolejność</th>
                          <th>Slajd</th>
                          <th>Tytuł slajdu</th>
                          <th>Kategorie egzaminów</th>
                          <th style="width: 4rem">Akcje</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-slide>
                        <tr>
                          <td>{{ slide.slideOrder }}</td>
                          <td>
                            <img
                              *ngIf="slide.imageLink"
                              [src]="getSlideImageUrl(slide.imageLink)"
                              alt=""
                              class="slide-thumbnail"
                            />
                          </td>
                          <td class="name-col">{{ slide.slideTitle }}</td>
                          <td>{{ getSlideExamNames(slide) }}</td>
                          <td>
                            <button
                              type="button"
                              class="pi pi-pencil cursor-pointer text-center appear transparent-button"
                              pTooltip="Edytuj slajd"
                              tooltipPosition="bottom"
                              (click)="openSlideDetails(topic, slide)"
                              data-clarity-unmask="true"
                            ></button>
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="5">Brak slajdów</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4">Brak rozdziałów</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">Brak działów</td>
    </tr>
  </ng-template>
</p-table>

<app-category-details
  [(detailsControl)]="categoryDetailsControl"
  [category]="selectedCategory"
  [categoryList]="categories"
  [categoryIndex]="categoryIndex"
  (refreshCategories)="load()"
></app-category-details>

<app-topic-details
  [(detailsControl)]="topicDetailsControl"
  [topic]="selectedTopic"
  [topicList]="topicSiblings"
  [topicIndex]="topicIndex"
  (refreshTopics)="load()"
></app-topic-details>

<app-content-details
  [(detailsControl)]="slideDetailsControl"
  [topic]="selectedSlide"
  [topicList]="slideSiblings"
  [topicIndex]="slideIndex"
  (refreshTopics)="load()"
></app-content-details>
